import {userConstants} from '../constants/userConstants';

// Updates an entity cache in response to any action with response.entities.
export function user(state = {isLoading: false}, action) {

    switch (action.type) {
        case userConstants.USER_REQUEST:
            return {...state, isLoading: true};

        case userConstants.USER_SUCCESS:
            return {...state, isLoading: false, isLoggedIn: true};

        case userConstants.USER_INFO_SUCCESS:
            let us = action.user.user
            return {
                ...state,
                isLoading: false,
                id: us.id,
                login: us.login,
                addr: us.mfgId,
                name: us.name,
                lastName: us.lastName,
                isLoggedIn: true,
                loginAsRight: us.loginAsRight,
                settings: us.settings,
                privileges: us.privileges,
            };

        case userConstants.USER_FAILURE:
            return {...state, isLoading: false}

        case userConstants.USER_CHANGE_LANGUE:
            return {...state, lang: action.lang}

        case userConstants.LOGOUT:
            return {...state, isLoggedIn: false}
        default:
            return state;
    }
}
